import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { getSubscriptionsAction } from "../actions/get-subscriptions.action";
import { SubscriptionsState } from "domain/subscriptions/entities/interfaces/subscriptions-state.interface";

const getSubscriptionsCases = (
  builder: ActionReducerMapBuilder<SubscriptionsState>
) => {
  builder.addCase(getSubscriptionsAction.pending, (state) => {
    state.isLoadingSubscriptions = true;
  });
  builder.addCase(getSubscriptionsAction.fulfilled, (state, action) => {
    state.subscriptions = action.payload;
    state.isLoadingSubscriptions = false;
  });
  builder.addCase(getSubscriptionsAction.rejected, (state) => {
    state.isLoadingSubscriptions = false;
  });
};

export default getSubscriptionsCases;
